module.exports = __webpack_public_path__ + "img/bg.5576c907.png";